import { render, staticRenderFns } from "./AddPropertyClassModal.vue?vue&type=template&id=5607ce70"
import script from "./AddPropertyClassModal.vue?vue&type=script&lang=js"
export * from "./AddPropertyClassModal.vue?vue&type=script&lang=js"
import style0 from "./AddPropertyClassModal.vue?vue&type=style&index=0&id=5607ce70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports